import React from 'react'
import { useDispatch } from 'react-redux';
import { openPopup } from '../../../store/popupSlice';
import { Link } from 'react-router-dom';
import { BaseUrl } from '../../helper/BaseUrl';
import Breadcrumb from '../../../component/Breadcrumb';

export default function CaseNewDetailHead({data}) {
  const dispath = useDispatch();
  const breadcrumbData = {
  newClass:"",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"case study",
      slug:"/case-study"
    },
    {
      page: data?.title?.slice(0,12) +"...",
      slug:`/case-study/${data?.slug}`
    },
  ]
}
  return (
    <>
      <section className="casenew-details-head header-gap">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="casenew-details-head-content">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <h1 className='heading'>{data?.title}</h1>
                <p>{data?.brief}</p>
                <Link onClick={() => dispath(openPopup())} className="default-btn">Check out how</Link>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="casenew-details-head-img">
                <img src={BaseUrl + data?.banner} alt={data?.alt_banner} className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
